var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8NativoDeReagir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "16px",
    height: "16px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#4d4d4d",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,34c-12.9,0 -23,-4.4 -23,-10c0,-5.6 10.1,-10 23,-10c12.9,0 23,4.4 23,10c0,5.6 -10.1,10 -23,10zM24,16c-12.6,0 -21,4.1 -21,8c0,3.9 8.4,8 21,8c12.6,0 21,-4.1 21,-8c0,-3.9 -8.4,-8 -21,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1,44.6c-1,0 -1.8,-0.2 -2.6,-0.7c-4.9,-2.8 -3.6,-13.7 2.8,-24.9v0c3,-5.2 6.7,-9.6 10.3,-12.4c3.9,-3 7.4,-3.9 9.8,-2.5c2.5,1.4 3.4,4.9 2.8,9.8c-0.6,4.6 -2.6,10 -5.6,15.2c-3,5.2 -6.7,9.6 -10.3,12.4c-2.6,2 -5.1,3.1 -7.2,3.1zM32.9,5.4c-1.6,0 -3.7,0.9 -6,2.7c-3.4,2.7 -6.9,6.9 -9.8,11.9v0c-6.3,10.9 -6.9,20.3 -3.6,22.2c1.7,1 4.5,0.1 7.6,-2.3c3.4,-2.7 6.9,-6.9 9.8,-11.9c2.9,-5 4.8,-10.1 5.4,-14.4c0.5,-4 -0.1,-6.8 -1.8,-7.8c-0.5,-0.2 -1,-0.4 -1.6,-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,44.6c-5,0 -12.2,-6.1 -17.6,-15.6c-6.5,-11.2 -7.8,-22.1 -2.9,-24.9v0c4.9,-2.8 13.7,3.7 20.2,14.9c3,5.2 5,10.6 5.6,15.2c0.7,4.9 -0.3,8.3 -2.8,9.8c-0.8,0.4 -1.6,0.6 -2.5,0.6zM13.5,5.8c-3.3,1.9 -2.7,11.3 3.6,22.2c6.3,10.9 14.1,16.1 17.4,14.2c1.7,-1 2.3,-3.8 1.8,-7.8c-0.6,-4.3 -2.5,-9.4 -5.4,-14.4c-6.3,-10.9 -14.1,-16.1 -17.4,-14.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NativoDeReagir);
export default __webpack_public_path__ + "static/media/icons8-nativo-de-reagir.4e68ad5b98b67965923317ed22fa513b.svg";
export { ForwardRef as ReactComponent };